export default {
    'external-account': "المورد",
    'generate-buy-invoice': "توليد فاتورة شراء",
    'fill-invoice-data': "تعبئة بيانات الفاتورة",
    'choose-invoice-entries': "اختيار بنود الفاتورة",
    "order-no": "رقم الطلبية",
    "generate-invoice": "توليد فاتورة",
    "invoice-generated":"تم توليد فاتورة شراء ",
    "show-invoice": "عرض الفاتورة",
    'create-order': "إنشاء طلبية",
    "order-updated": "تم تحديث بيانات الطلبية بنجاح",
    "order-delete-alert": "هل أنت متأكد من حذف الطلبية؟",
    "order-delete": "حذف طلبية",
    "order-date": "تاريخ الطلبية",
    "order-status": "حالة الطلبية",
    'not-defined': "غير محددة",
    'in-progress': "قيد التعديل",
    'done': "منجزة"

}